import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';

/**
 * @slot - Contents placed within the button
 */
@Component({
  tag: 'wb-header-meta-link',
  styleUrl: 'header-meta-link.scss',
  shadow: true,
})
export class HeaderMetaLinkComponent implements ComponentInterface {
  /** passed through to internal <a> */
  @Prop()
  public href: string;

  /** passed through to internal <a> */
  @Prop()
  public download: any;

  /** passed through to internal <a> */
  @Prop()
  public referrerPolicy: ReferrerPolicy;

  /** passed through to internal <a> */
  @Prop()
  public rel: string;

  /** passed through to internal <a> */
  @Prop()
  public target: string;

  public render(): JSX.Element {
    return (
      <Host class="wb-header-meta-link">
        <a href={this.href} download={this.download} referrerPolicy={this.referrerPolicy} rel={this.rel} target={this.target}>
          <slot></slot>
        </a>
      </Host>
    );
  }
}
